<!-- 内容场景 -->
<template>
    <div class="advantage_wrapper">
        <!-- part1 -->
        <div class="section_item advantage_section1 platform_section1">
            <div class="wrapper">
                <div class="block">
                    <div class="title">{{section1.title}}</div>
                    <div class="description">{{section1.description}}</div>
                    <el-button @click="bind_toggle_form('cooperation')" type="warning" class="btn_init">{{section1.cta}}</el-button>    
                </div> 
                <img :src="section1.link" alt="">
            </div>
        </div>
         <!-- part2 -->
        <div class="section_item advantage_section2 platform_image_text">
            <div v-for="(item, idx) in section2.data || []"
                :key="idx"
                class="show_wrapper">
                <div class="show_content">
                    <div class="title_en">{{item.title_en}}</div>
                    <div class="title">{{item.title}}</div>
                    <div class="underline"></div>
                    <div class="description">{{item.description}}</div>
                </div>
                <div
                    :style="{float: item.pos}" 
                    class="show_img"><img :src="item.link" alt=""></div>
            </div>
        </div>
        <!-- part2 -->
        <div class="section_item advantage_section3 ad_list platform_image_text wow">
            <div class="show_wrapper">
                <div class="show_content">
                    <div class="title_en">{{section3.title_en}}</div>
                    <div class="title">{{section3.title}}</div>
                    <div class="underline"></div>
                    <div class="description">{{section3.description}}</div>
                </div>
                <div :style="{float: section3.pos}" 
                    class="show_img">
                    <div v-show='!isIE9' class="swiper-container content_slide_wrapper">
                        <div class="swiper-wrapper">
                            <div v-for="(item, idx) in section3.data || []"
                                :key="idx" 
                                class="banner_item_wrapper swiper-slide swiper-no-swiping">
                                <div class="banner_item">
                                    <div class="img"><img :src="item.val" alt=""></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-carousel 
                        ref="carousel"
                        v-show='isIE9'
                        class="slide_img IE9item"
                        height="400px"
                        indicator-position='none'
                        arrow='never'
                        :autoplay="false">
                        <el-carousel-item 
                            v-for="(item, idx) in section3.data || []"
                            :key="idx" >
                            <div class="banner_item">
                                <div class="img"><img :src="item.val" alt=""></div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                    <div class="ctr_wrapper">
                        <div v-for="(item, idx) in section3.data || []"
                            :key="idx" 
                            class="ctr_item"
                            :class="{'active': item.active}"
                            @click="bind_toggle_ad(idx)">
                            {{item.key}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- part4 -->
        <div class="section_item advantage_section4">
            <div class="form_wrapper">
                <CmsForm/>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Vue from 'vue';
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/advantage.js';
    import { WOW } from 'wowjs';
    export default {
        name: "Content",
        components: {
            CmsForm,
            BottomMsg
        },
        computed: {
            section1() {
                return data.content && data.content.section1;
            },
            section2() {
                return data.content && data.content.section2;
            },
            section3() {
                return data.content && data.content.section3;
            },
            isIE9() {
                return !('placeholder' in document.createElement('input'));
            }
        },
        data() {
            return {
                act_idx: 0
            }
        },
        mounted() {
            if (this.isIE9) {
                this.$refs.carousel.setActiveItem(0);
            } else {
                this.mySwiper = new Swiper('.content_slide_wrapper', {
                    noSwiping : true
                })
                this.mySwiper.slideTo(0, 500, false);
            }
            // 广告轮播图引导动画
            let wow = new WOW(
                {
                    live: false,
                    animateClass: 'animated',
                    offset: 100
                }
            );
            wow.init();
        },
        methods: {
            bind_toggle_ad(idx) {
                let ori_idx = this.act_idx;
                Vue.set(this.section3.data[ori_idx], 'active', false);
                Vue.set(this.section3.data[idx], 'active', true);
                this.act_idx = idx;
                this.mySwiper && this.mySwiper.slideTo(idx, 500, false)
                this.$refs.carousel && this.$refs.carousel.setActiveItem(idx);
                this.$forceUpdate();
            },
            // 显示合作/登录组件
            bind_toggle_form(flag) {
                // 百度统计
                window._hmt.push(['_trackEvent', 'ctaTrigger', 'advantage_content', flag]);
                this.$emit('toggleForm', flag);
            }
        }
    }
</script>

<style scoped>
    /* 整个首页的包裹样式 */
    .advantage_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
    }
    /* 第一部分的样式 */
    .advantage_section1 {
        background: linear-gradient(0deg, #f5f9ff 0%, #fcfdff 100%);
        background: #fcfdff\9\0;
    }
     /* 第二部分的样式 */
    .advantage_section2 {
        background: #fff;
    }
     /* 第三部分的样式 */
    .advantage_section3 {
        background: #fff;
    }
    /* 广告轮播图引导动画 */
    .advantage_section3.animated .ctr_wrapper .ctr_item:nth-child(2) {
        animation: guide 3s linear;
    }
    /* 标题包裹狂 */
    .advantage_section3 .show_wrapper {
        width: 1280px;
        height: 600px;
        margin: 0 auto;
        padding: 70px 0 70px 0;
        overflow: hidden;
    }
    
    .show_img .content_slide_wrapper, .show_img .IE9item{
        width: 293px;
        height: 400px;
    }
    /* ie9的内容轮播图 */
    .show_img .IE9item {
        left: 50%;
        transform: translateX(-50%);
        -ms-transform: translateX(-50%);
    }
    .IE9item .banner_item {
        width: 100%;
        height: 100%;;
    }

    .content_slide_wrapper img, .IE9item img{
        position: relative !important;
        width: 100% !important;
        height: 100% !important;
        left: 0 !important;
        transform: translate(0, 0) !important;
        -ms-transform: translate(0, 0) !important;

    }
    /* 切换广告菜单栏 */
    .ctr_wrapper {
        background: #fff;
        box-shadow: -1px -10px 30px 0 rgba(204,230,255,0.36);
    }
    .ctr_wrapper .ctr_item {
        width: 110px;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        color: #bebfc1;
        display: inline-block;
        cursor: pointer;
    }
    .ctr_wrapper .ctr_item.active {
        color: #292c33;
    }
     /* 第五部分的样式 */
    .advantage_section4 {
        background: #FAFCFF;
        height: auto;
    }

    /* 标题包裹狂 */
    .advantage_section4 .form_wrapper {
        width: 1280px;
        margin: 0 auto;
        margin-top: 48px;
        margin-bottom: 54px;
    }

</style>





// WEBPACK FOOTER //
// src/containers/Advantage/Content.vue